@import (reference) "../../references.less";

.root {
  .R(padding-bottom, 50);
  position: relative;
  background: @color-blue-1;
}

.header {
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  .R(height, 80, 120);
  width: 100%;
  background: @color-blue-1;
  z-index: 1;
}

.headerBackground {
  position: absolute;
  top: 0;
  width: 100%;
  .R(height, 130, 300);
  background: @color-blue-1;
}

.restartButton {
  .absoluteCenter(y);
  .R(left, 13, 30);
}

.logo {
  .absoluteCenter();
  transform: translate(-50%, -50%) scale(0.5);
}

.downloadButton {
  position: fixed;
  .R(top, 20);
  .R(right, 20);

  @media (min-width: @breakpoint-laptop) {
    .R(top, 30);
    .R(right, 30);
    .R(width, 250);
  }
}

.list {
  .R(margin-top, 110, 130);
  margin: auto;
  width: 80%;
  @media (min-width: @breakpoint-laptop) {
    .R(width, 816);
    margin-left: auto;
    margin-right: auto;
  }
}

.item {
  .R(margin-top, 50);
  position: relative;
}
